import { autoinject } from 'aurelia-framework';

import { GenericApi, ParamType } from '~/api/generic-api';
import { BatchCode } from '~/models/entities/batch-process';
import { ValueMap } from '~/models/value-map';
import { FetchUtils, HttpMethod } from '~/utils/fetch-utils';

export class BatchProcessingCentreApi {
	private static readonly BATCH_ENDPOINT = 'api/batches';
	/**
	 * Get batch codes
	 */
	public static getBatchCodes(): Promise<BatchCode[]> {
		return FetchUtils.getJSON(
			BatchProcessingCentreApi.BATCH_ENDPOINT + '/batch-codes',
		);
	}

	/**
	 * Process batch
	 * @param recordId record ID
	 */
	public static async processBatch(recordId: string | number): Promise<void> {
		return FetchUtils.fetchJSON(
			HttpMethod.PUT,
			BatchProcessingCentreApi.BATCH_ENDPOINT +
				'/' +
				recordId +
				'/process',
		);
	}

	public static getBatch(recordId: string | number): Promise<ValueMap> {
		return FetchUtils.fetchJSON<ValueMap>(
			HttpMethod.GET,
			BatchProcessingCentreApi.BATCH_ENDPOINT + '/' + recordId,
		);
	}
}
